/* ============================================================
   AMGZAL — interactions (menu, search, AJAX cart drawer)
   File: assets/amgzal.js
   Load it: in layout/theme.liquid just before </body> add:
     <script src="{{ 'amgzal.js' | asset_url }}" defer></script>
   Works with Shopify's AJAX Cart API on any OS 2.0 theme.
   ============================================================ */
(function () {
  var money = function (cents) {
    try {
      if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) {
        return Shopify.formatMoney(cents, theme.moneyFormat);
      }
    } catch (e) {}
    return '\u20AC' + (cents / 100).toFixed(0);
  };

  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- open / close panels ---------- */
  function setOpen(el, on) { if (el) el.classList.toggle('is-open', !!on); }
  function lockScroll(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  var menu = qs('[data-amg-menu]');
  var search = qs('[data-amg-search]');
  var cart = qs('[data-amg-cart]');
  var overlay = qs('[data-amg-overlay]');
  var guide = qs('[data-amg-guide]');

  function closeAll() {
    setOpen(menu, false); setOpen(search, false); setOpen(cart, false); setOpen(overlay, false); setOpen(guide, false);
    if (guide) guide.setAttribute('aria-hidden', 'true');
    lockScroll(false);
  }

  function openGuide() { if (!guide) return; setOpen(guide, true); guide.setAttribute('aria-hidden', 'false'); lockScroll(true); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-amg-menu-open],[data-amg-menu-close],[data-amg-search-open],[data-amg-search-close],[data-amg-cart-open],[data-amg-cart-close],[data-amg-guide-open],[data-amg-guide-close],[data-amg-overlay]');
    if (!t) { if (guide && guide.classList.contains('is-open') && e.target === guide) closeAll(); return; }
    if (t.hasAttribute('data-amg-menu-open')) { e.preventDefault(); setOpen(menu, true); lockScroll(true); }
    else if (t.hasAttribute('data-amg-search-open')) { e.preventDefault(); setOpen(search, true); var i = qs('input', search); if (i) setTimeout(function(){ i.focus(); }, 80); }
    else if (t.hasAttribute('data-amg-cart-open')) { e.preventDefault(); openCart(); }
    else if (t.hasAttribute('data-amg-guide-open')) { e.preventDefault(); openGuide(); }
    else { e.preventDefault(); closeAll(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- cart drawer ---------- */
  var cartBody = qs('[data-amg-cart-body]');
  var cartFoot = qs('[data-amg-cart-foot]');

  function renderCart(data) {
    qsa('[data-amg-cart-count]').forEach(function (n) { n.textContent = data.item_count; });
    if (!cartBody) return;
    if (!data.items || !data.items.length) {
      cartBody.innerHTML =
        '<div class="amg-cart__empty">' +
          '<p class="amg-serif" style="font-size:26px;margin:0 0 6px">Your bag is empty</p>' +
          '<p style="font-size:13px;opacity:.6;margin:0 0 24px">Every piece is one of a kind. Begin with the new drop.</p>' +
          '<a class="amg-btn amg-btn--dark" href="/collections/all">Shop New Drop</a>' +
        '</div>';
      cartFoot.innerHTML = '';
      return;
    }
    cartBody.innerHTML = data.items.map(function (it) {
      var opts = (it.options_with_values || []).map(function (o) { return o.value; }).join(' \u00b7 ');
      return '<div class="amg-cart__line">' +
        '<img src="' + (it.image ? it.image.replace(/(\.[^.]+)(\?.*)?$/, '_160x200$1') : '') + '" alt="' + it.title + '">' +
        '<div style="flex:1">' +
          '<div style="font-family:var(--font-commerce);font-weight:500;font-size:15px;line-height:1.2;letter-spacing:-.01em">' + it.product_title + '</div>' +
          '<div style="font-size:11px;letter-spacing:.12em;text-transform:uppercase;opacity:.6;margin:4px 0 8px">' + (opts || it.variant_title || '') + ' \u00b7 Qty ' + it.quantity + '</div>' +
          '<div style="display:flex;align-items:center;justify-content:space-between">' +
            '<span style="font-size:14px">' + money(it.final_line_price) + '</span>' +
            '<button type="button" data-amg-remove="' + it.key + '" style="font-size:10px;letter-spacing:.14em;text-transform:uppercase;opacity:.55;text-decoration:underline;background:none;border:none;cursor:pointer">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
    var ship = '';
    var threshold = (window.AMGZAL && window.AMGZAL.freeShip) || 0;
    if (threshold > 0) {
      var pct = Math.min(100, Math.round(data.total_price / threshold * 100));
      var remain = threshold - data.total_price;
      ship = '<div class="amg-ship">' +
        '<p class="amg-ship__msg">' + (remain > 0
          ? 'You’re <b>' + money(remain) + '</b> away from free worldwide shipping.'
          : '✓ You’ve unlocked <b>free worldwide shipping</b>.') + '</p>' +
        '<div class="amg-ship__track"><div class="amg-ship__fill" style="width:' + pct + '%"></div></div>' +
      '</div>';
    }
    cartFoot.innerHTML = ship +
      '<div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:4px">' +
        '<span style="font-size:12px;letter-spacing:.18em;text-transform:uppercase">Subtotal</span>' +
        '<span style="font-family:var(--font-commerce);font-weight:500;font-size:18px">' + money(data.total_price) + '</span>' +
      '</div>' +
      '<p style="font-size:11px;opacity:.55;margin:0 0 16px">Taxes &amp; shipping calculated at checkout.</p>' +
      '<a class="amg-btn amg-btn--dark" style="width:100%;text-align:center;display:block" href="/checkout">Checkout</a>';
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { renderCart(d); return d; });
  }

  function openCart() { fetchCart(); setOpen(overlay, true); setOpen(cart, true); lockScroll(true); }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-amg-remove]');
    if (!rm) return;
    e.preventDefault();
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: rm.getAttribute('data-amg-remove'), quantity: 0 })
    }).then(function (r) { return r.json(); }).then(renderCart);
  });

  /* ---------- intercept product add-to-cart forms ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.dataset._t = btn.textContent; btn.textContent = 'Adding\u2026'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () { openCart(); if (btn) btn.textContent = btn.dataset._t || 'Add to Bag'; })
      .catch(function () { if (btn) btn.textContent = btn.dataset._t || 'Add to Bag'; form.submit(); });
  });

  /* ---------- product gallery thumbnails ---------- */
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-amg-thumb]');
    if (!th) return;
    var main = qs('[data-amg-main]');
    if (main) main.src = th.getAttribute('data-amg-thumb');
    qsa('[data-amg-thumb]').forEach(function (n) { n.classList.toggle('is-active', n === th); });
  });

  /* ---------- product size selector (mirrors hidden variant select) ---------- */
  document.addEventListener('click', function (e) {
    var sz = e.target.closest('[data-amg-size]');
    if (!sz || sz.disabled) return;
    qsa('[data-amg-size]').forEach(function (n) { n.classList.toggle('is-active', n === sz); });
    var sel = qs('[data-amg-variant-select]');
    if (sel) { sel.value = sz.getAttribute('data-amg-variant'); sel.dispatchEvent(new Event('change', { bubbles: true })); }

    /* reflect the selection in the label, Add-to-Bag button and sticky bar */
    var title = sz.getAttribute('data-amg-vtitle');
    var price = sz.getAttribute('data-amg-vprice');
    var avail = sz.getAttribute('data-amg-vavail') === 'true';
    var cur = qs('[data-amg-size-current]'); if (cur && title) cur.textContent = title;
    var stp = qs('[data-amg-sticky-price]'); if (stp && price) stp.textContent = price;
    qsa('[data-amg-add]').forEach(function (b) {
      b.innerHTML = avail ? ('Add to Bag — ' + price) : 'Sold out';
      b.disabled = !avail;
    });
  });

  /* ---------- size guide cm / inch toggle ---------- */
  document.addEventListener('click', function (e) {
    var ub = e.target.closest('[data-amg-unit-btn]');
    if (!ub) return;
    var unit = ub.getAttribute('data-amg-unit-btn');
    var wrap = ub.closest('.amg-guide__panel') || document;
    qsa('[data-amg-unit-btn]', wrap).forEach(function (b) { b.classList.toggle('is-active', b === ub); });
    qsa('[data-amg-cm]', wrap).forEach(function (td) {
      var raw = td.getAttribute('data-amg-cm');
      if (unit !== 'in') { td.textContent = raw; return; }
      /* convert every number in the cell (handles ranges like "102–110") */
      td.textContent = raw.replace(/[0-9]+(\.[0-9]+)?/g, function (n) {
        var inch = Math.round(parseFloat(n) / 2.54 * 2) / 2; /* nearest 0.5" */
        return inch % 1 === 0 ? inch.toFixed(0) : inch.toFixed(1);
      });
    });
    qsa('[data-amg-unit]', wrap).forEach(function (s) { s.textContent = unit === 'in' ? '(in)' : '(cm)'; });
  });

  /* init counts on load */
  fetchCart();
})();
